import React from 'react'

export const DownloadIcon = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"  xmlns="http://www.w3.org/2000/svg">
		<path
			d="M17.5099 11.047C17.1701 11.047 16.8947 11.3223 16.8947 11.6621V16.4193H3.73032C3.73032 16.4193 3.73032 17.0346 2.5 17.0345C2.5 17.3743 2.77541 17.6497 3.11516 17.6497H17.5098C17.8496 17.6497 18.125 17.3743 18.125 17.0345V11.6621C18.125 11.3224 17.8496 11.047 17.5099 11.047Z"
			/>
		<path
			d="M3.11513 11.047C3.45491 11.047 3.73029 11.3223 3.73029 11.6621L3.73032 16.4193H16.8947C16.8947 16.4193 16.8947 17.0346 18.125 17.0345C18.125 17.3743 17.8496 17.6497 17.5098 17.6497H3.11516C2.77541 17.6497 2.5 17.3743 2.5 17.0345L2.5 11.6621C2.49997 11.3224 2.77538 11.047 3.11513 11.047Z"
			 />
		<path
			d="M11.0893 10.7131H12.5878C12.7236 10.7131 12.7986 10.8692 12.7155 10.9767L10.4446 13.8498C10.4294 13.8692 10.41 13.8849 10.3879 13.8957C10.3657 13.9065 10.3414 13.9121 10.3168 13.9121C10.2922 13.9121 10.2679 13.9065 10.2458 13.8957C10.2236 13.8849 10.2042 13.8692 10.1891 13.8498L7.91813 10.9747C7.835 10.8692 7.91002 10.7131 8.04587 10.7131H9.54834L9.54834 3.85362C9.54834 3.7644 9.62134 3.69141 9.71056 3.69141L10.9271 3.69141C11.0163 3.69141 11.0893 3.7644 11.0893 3.85362L11.0893 10.7131Z"
			 />
	</svg>

)
